import React from 'react';
import { map, range } from 'lodash';
import { Skeleton } from '@mui/material';
import { Stack } from 'new/elements/Stack';

export const ContentSkeleton = ({ numItems }: { numItems: number }) => (
  <Stack padding="16px">
    {map(range(numItems), (index) => (
      <Skeleton key={index} style={{ minHeight: 42 }} />
    ))}
  </Stack>
);
